import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class MissionService {
  private missionAnnouncedSource = new Subject<string>();

  missionAnnounced$ = this.missionAnnouncedSource.asObservable();

  announceMission(data: string) {
    this.missionAnnouncedSource.next(data);
  }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/app.constant.ts